export default __webpack_public_path__ + "static/media/agent-display.3de2c885.jpg";